import { PublicClientApplication, BrowserCacheLocation  } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: "ac8541de-8db4-4f7f-80f2-360f684b5653",
        authority: "https://login.microsoftonline.com/common",
        redirectUri: window.location.origin + '/login',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true,
    },
    system: {
        allowNativeBroker: true,
        allowRedirectInIframe: true,
    },
};

const msalInstance = new PublicClientApplication(msalConfig);

async function initializeMsal() {
    await msalInstance.initialize();
}

export { msalInstance, initializeMsal };
